import { useEffect, useRef } from "react"
import { backdropDismiss } from "../../utils/backdropDismiss"

// Modal error display for action failures on cards and pages: unlike an
// inline label, it demands an explicit dismissal and can't linger unnoticed.
// Mount conditionally on the error state:
//   {error && <ErrorDialog message={error} onClose={() => setError("")} />}
export default function ErrorDialog({ title = "Something went wrong", message, onClose }: {
  title?: string
  message: string
  onClose: () => void
}) {
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    dialogRef.current?.showModal()
  }, [])

  return (
    <dialog
      ref={dialogRef}
      className="redeem-dialog"
      onClose={onClose}
      {...backdropDismiss(() => { dialogRef.current?.close() })}
    >
      <div className="redeem-dialog-content">
        <button className="redeem-dialog-close" onClick={() => dialogRef.current?.close()} aria-label="Close">&times;</button>
        <h2 className="redeem-dialog-title">{title}</h2>
        <p className="generate-codes-error">{message}</p>
        <div className="redeem-actions">
          <button className="btn-upgrade" onClick={() => dialogRef.current?.close()}>Dismiss</button>
        </div>
      </div>
    </dialog>
  )
}
